import React from 'react';
import { DungeonBotPage } from '../DungeonBotPage.js';

export const CharacterManagementPage: React.FC = () => {
  return <DungeonBotPage initialSection="characters" />;
};
